module.exports = __webpack_public_path__ + "static/img/surface.2d49aeb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/surface.png
// module id = CPGD
// module chunks = 1